(function() {
  'use strict';

  angular
    .module('admin.shinies.service', [])
    .factory('ShiniesAdminService', ShiniesAdminService);

  /** @ngInject */
  function ShiniesAdminService($http, $q, API) {

    function list(startDate, endDate, chId, setId, collectibleId){
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/shinies/report?start-date=' + startDate + '&end-date=' + endDate + '&chId=' + chId + '&setId=' + setId + '&collectibleId=' + collectibleId)
        .success(defered.resolve);

      return defered.promise;
    }

    function listUsers(shinyId){
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/shinies/report/' + shinyId + '/users')
        .success(defered.resolve);

      return defered.promise;
    }

    return{
      list: list,
      listUsers: listUsers
    };

  }

})();
